import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  IonCard,
  IonCardContent,
  IonItem,
  IonText,
  IonList,
} from "@ionic/react";
import {
  getTeamRoundAggregateScore,
  getTeamTableScore,
  uniqBy,
} from "services/util";

interface props {
  teams: any;
  progress: any;
  quizData: any;
}

const AggregateResults: React.FC<props> = ({ teams, progress, quizData }) => {
  const [teamStatus, setTeamStatus] = useState<any>([]);

  const score = (team: any) => {
    if (quizData.quizConfig.format.rounds === progress.round) {
      return getTeamTableScore(team, progress);
    } else {
      return getTeamRoundAggregateScore(team, progress);
    }
  };

  // const sortByTeamName = (a: any, b: any) => {
  //   const nameA = a.teamName.toUpperCase(); // ignore upper and lowercase
  //   const nameB = b.teamName.toUpperCase();
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }

  //   return 0;
  // };

  // const sortByScore = (a: any, b: any) => {};

  const sortByScoreAndBreaker = (a: any, b: any) => {
    if (b.score !== a.score) return b.score - a.score;

    if (a.breakerDiff === null) {
      return 1;
    }

    if (b.breakerDiff === null) {
      return -1;
    }

    return a.breakerDiff - b.breakerDiff;
  };

  useEffect(() => {
    let orderedTeams = teams
      .map((team: any) => {
        return {
          teamName: team.teamName,
          score: score(team),
          breakerDiff: team.breaker?.proximity,
          breakerRank: team.breaker?.rank,
          scoreDisplay: score(team),
        };
      })

      .sort(sortByScoreAndBreaker)
      .map((team: any, i: any) => {
        return { ...team, index: i };
      });

    let firstByScore = uniqBy(orderedTeams, "score");
    console.log(firstByScore);
    firstByScore.forEach((team: any) => {
      let scoreCount = orderedTeams.filter(
        (t: any) => t.score === team.score
      ).length;

      if (team.breakerDiff !== null && team.breakerDiff >= 0 && scoreCount > 1)
        orderedTeams[team.index].scoreDisplay = team.score + "*BQ";
    });

    setTeamStatus(orderedTeams);

    // setTeamStatus(
    //   orderedTeams &&
    //     orderedTeams
    //       .map((team: any) => {
    //         return {
    //           teamName: team.teamName,
    //           scoreDisplay: team.score,
    //         };
    //       })
    //       .sort((a: any, b: any) => b.scoreDisplay - a.scoreDisplay)
    // );

    //eslint-disable-next-line
  }, [teams]);

  console.log(teamStatus);

  return (
    <IonCard style={{ maxWidth: "600px" }}>
      <IonCardContent>
        <IonList>
          {teamStatus &&
            teamStatus.length > 0 &&
            teamStatus.map((team: any, i: any) => {
              return (
                <IonItem key={i} lines="full">
                  <IonText
                    slot="start"
                    style={{ width: "100%", maxWidth: "70%" }}
                  >
                    {team.teamName}
                  </IonText>
                  <IonText>{team.scoreDisplay}</IonText>
                </IonItem>
              );
            })}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};
const mapStateToProps = (state: any) => ({
  teams: state.teams.teams,
  progress: state.quiz.progress,
  quizData: state.quiz,
});

export default connect(mapStateToProps, {})(AggregateResults);
